import React, { useState } from 'react';
import models_icon from '../../assets/icons/models.svg'

const NewFolderView = (props) => {

    const emptyFolderDefinition = {
        name:"",
        description:""
    }
    
    const [newFolder, setNewFolder] = useState({...emptyFolderDefinition})

    function handleChange(e) {
        const { name, value } = e.target;
        setNewFolder(inputs => ({ ...inputs, [name]: value }));
        console.log(newFolder)
        props.setNewFolderDef({...newFolder,[name]: value})
    }

    function handleCheckedChange(e) {
        const { name, value, checked } = e.target;
        setNewFolder(inputs => ({ ...inputs, [name]: checked }));
        
        props.setNewFolderDef({...newFolder,[name]: checked})
    }


    return (
        <div style={{background:'#EFEFEF', display:'flex', justifyContent:'center', flexDirection: 'row'}}>
                        
            <div style={{padding:3, maxWidth:600, minWidth:300, width:'100%'}}>
               
                <div style={{background:'#FFFFFF',display:'flex', justifyContent:'flex-start',padding:0, border:'1px solid #CCCCCC', borderRadius:3, overflow:'hidden', margin:5, maxWidth:600}}>
                    <div align="left" style={{display:'inline-block',align:'left', background:'#CCCCCC'}}>
                        <img src={models_icon} className="module-logo" alt="logo" style={{margin:8}} />
                    </div>
                    <div style={{display:'inline-block', width:'100%', margin:5, verticalAlign:'top',display:'flex', justifyContent:'flex-start',flexDirection: 'column', alignItems:'flex-start'}}>
                        <table>
                            <tr>
                                <td className="input-label" >Name :</td>
                                <td><input name="name" className="text-input" value={newFolder.name} onChange={handleChange} type="text"/></td>
                            </tr>
                            <tr>
                                <td className="input-label">Description :</td>
                                <td className="absorbing-column"><textarea name="description" className="text-input" rows="5" value={newFolder.description} onChange={handleChange}/></td>
                            </tr>
                        </table>
                        </div>
                </div>

                
            </div>
        </div>
    )
}

export default NewFolderView;